import type { CSSProperties } from "react";
import type { FilterKind } from "../types/drink";

interface Props {
  active: FilterKind;
  onChange: (next: FilterKind) => void;
}

const FILTERS: { value: FilterKind; label: string }[] = [
  { value: "today",          label: "Today" },
  { value: "popular",        label: "Popular" },
  { value: "all",            label: "All" },
  { value: "cocktails",      label: "Cocktails" },
  { value: "old_fashioned",  label: "Old Fashioned" },
];

export default function FilterPills({ active, onChange }: Props) {
  // Toggle-button group with aria-pressed — not a tablist (no arrow-key
  // tab navigation; mutually-exclusive filter is the only pattern).
  return (
    <div style={styles.row} role="group" aria-label="Filter">
      {FILTERS.map((f) => {
        const isActive = active === f.value;
        return (
          <button
            key={f.value}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(f.value)}
            style={{
              ...styles.pill,
              background: isActive ? "var(--text)" : "var(--surface)",
              color: isActive ? "var(--bg)" : "var(--muted)",
              borderColor: isActive ? "var(--text)" : "var(--border)",
            }}
          >
            {f.label}
          </button>
        );
      })}
    </div>
  );
}

const styles: Record<string, CSSProperties> = {
  row: {
    display: "flex",
    flexWrap: "wrap",
    gap: 6,
  },
  pill: {
    flex: "1 1 auto",
    minHeight: 36,
    borderRadius: 11,
    border: "1px solid",
    fontSize: 11,
    fontWeight: 800,
    cursor: "pointer",
    whiteSpace: "nowrap",
    padding: "0 12px",
  },
};
